import { animate, query, stagger, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import { Config } from 'app/core/store/config/config.interface';
import { SalesOrganisationInfo } from 'app/core/store/customer-info/customer-info.interface';
import { AuthorizationMatrix } from 'app/core/store/session/authorization/authorization.interface';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Place } from '../../../core/interfaces/place.interface';
import { CustomerSummary } from '../../../core/store/contract-details/customer-summary/customer-summary.interface';
import { ContractInfo } from '../../../core/store/contract-info/contract-info.interface';
import { BaseContainer } from '../../base/BaseContainer';

@Component({
  selector: 'app-new-dashboard-container',
  templateUrl: './dashboard.container.html',
  styleUrls: ['./dashboard.container.scss'],
  animations: [
    trigger('tile', [
      transition(':enter', [
        query('.tile', [style({ opacity: 0, transform: 'translateY(-50px)' }), stagger(50, [animate('500ms ease-out', style({ opacity: 1, transform: 'translateY(0px)' }))])], { optional: true }),
      ]),
    ]),
  ],
})
export class DashboardContainer extends BaseContainer {
  customerSummary: CustomerSummary;
  authorization: AuthorizationMatrix;
  depots: Place[] = [];
  isSuperUser = false;
  showOrdersTile = false;
  showFlowsTile = false;
  contractInfo: ContractInfo;
  salesOrganisation: SalesOrganisationInfo;

  private launchpadUrl: string;

  constructor() {
    super();
    this.store
      .select(state => ({
        authorization: state.session.authorization.data,
        contractInfo: state.contractInfo,
        salesOrganisation: state.customerInfo?.salesOrganisation,
      }))
      .pipe(distinctUntilChanged(), takeUntil(this.destroyed$))
      .subscribe(({ authorization, contractInfo, salesOrganisation }) => {
        this.authorization = authorization;
        this.contractInfo = contractInfo;
        this.showFlowsTile = this.authorization.ACCESS['FLOWS'];
        this.showOrdersTile = this.authorization.ACCESS['ORDERS'];
        this.salesOrganisation = salesOrganisation;
      });

    this.store
      .select('config')
      .pipe(takeUntil(this.destroyed$))
      .subscribe((config: Config) => {
        this.launchpadUrl = config.launchpadUrl;
      });
  }

  gotoLaunchpadClicked() {
    if (window.location.href.indexOf('localhost:4200') > 0) {
      window.location.href = 'http://localhost:4300';
    } else {
      window.location.href = this.launchpadUrl;
    }
  }

}
